{
  "VALIDATION_FAILED": "تحقق من البيانات المدخلة وحاول مرة أخرى.",
  "UNAUTHENTICATED": "يرجى تسجيل الدخول للمتابعة.",
  "FORBIDDEN": "لا تملك صلاحية تنفيذ هذا الإجراء.",
  "NOT_FOUND": "العنصر المطلوب غير موجود.",
  "CONFLICT": "تعذر إتمام العملية بسبب تعارض في البيانات.",
  "UNIQUE_VIOLATION": "هذه القيمة مستخدمة مسبقا.",
  "FOREIGN_KEY_VIOLATION": "تعذر إتمام العملية بسبب ارتباط هذا العنصر بعناصر أخرى.",
  "RATE_LIMITED": "عدد كبير من المحاولات. حاول مرة أخرى بعد قليل.",
  "IDEMPOTENCY_KEY_REUSED": "تم إرسال هذا الطلب مسبقا بمحتوى مختلف.",
  "PAYLOAD_TOO_LARGE": "حجم البيانات المرسلة أكبر من المسموح به.",
  "UNPROCESSABLE": "تعذر معالجة الطلب.",
  "INTERNAL_ERROR": "تعذر تنفيذ الطلب بسبب خطأ داخلي في الخادم. أعد المحاولة، وإن تكرر الخطأ تواصل مع الدعم الفني.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا. حاول مرة أخرى لاحقا.",
  "NO_PLATFORM_ACCESS": "لا تملك صلاحية الوصول إلى هذا النظام.",
  "UA_UNAVAILABLE": "تعذر الاتصال بنظام الدخول الموحد. حاول مرة أخرى لاحقا.",
  "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم مسبقا.",
  "USER_ALREADY_EXISTS": "هذا الموظف مضاف مسبقا كمستخدم في هذا النظام.",
  "CURRENCY_NOT_FOUND": "العملة غير موجودة.",
  "CURRENCY_LOCKED": "لا يمكن تعديل هذه العملة.",
  "VIP_NOT_ENABLED": "أسعار VIP غير مفعلة لهذه العملة.",
  "VIP_NOT_PERMITTED": "لا تملك صلاحية تطبيق أسعار VIP.",
  "INSUFFICIENT_BALANCE": "لا يوجد رصيد كاف بهذه العملة في الصندوق أو الخزينة.",
  "HOLDER_NOT_FOUND": "الصندوق أو الخزينة غير موجود.",
  "HOLDER_ROUTE_NOT_ALLOWED": "هذا النقل غير مسموح بين الخزائن والصناديق.",
  "ALREADY_REVERSED": "تم عكس هذه العملية مسبقا.",
  "EXCHANGE_NOT_FOUND": "عملية الصرف غير موجودة.",
  "NOTES_REQUIRED": "يجب إدخال ملاحظات عند وجود فائض أو نقص.",
  "BOX_NOT_EMPTY": "يجب توريد النقد قبل إجراء هذا التغيير.",
  "CASHIER_NEEDS_ONE_BRANCH": "يجب أن يكون لأمين الصندوق فرع واحد فقط.",
  "BOX_NAME_TAKEN": "اسم الصندوق مستخدم في هذا الفرع.",
  "EMPLOYEE_NOT_ELIGIBLE": "يجب أن يكون الموظف فعالا وفرعه الوحيد فرع الصندوق.",
  "BOX_UNAVAILABLE": "لم يعد الصندوق متاحا، اختر صندوقا آخر.",
  "BOX_HAS_BALANCE": "لا يمكن إيقاف صندوق فيه رصيد، يجب توريد الرصيد أولا.",
  "SOLE_BOX_EMPLOYEE": "هذا الموظف وحده في الصندوق، أضف موظفا آخر أو أوقف الصندوق أولا.",
  "BOX_HAS_NO_EMPLOYEE": "لا يمكن تفعيل صندوق بلا موظفين، أضف موظفا أولا.",
  "SAME_CURRENCY": "اختر عملة مختلفة.",
  "IMAGE_INVALID": "صيغة الصورة أو حجمها غير مقبول.",
  "IMAGE_NOT_FOUND": "لم يتم العثور على الصورة.",
  "EXCHANGE_APP_NOT_CONFIGURED": "تطبيق الصرف غير مهيأ على الخادم. تواصل مع المسؤول.",
  "TABLET_NOT_CONFIGURED": "خدمة التابلت غير مهيأة على الخادم. تواصل مع المسؤول.",
  "TABLET_UNAVAILABLE": "تعذر الاتصال بخدمة التابلت. حاول مرة أخرى.",
  "TABLET_NOT_AVAILABLE": "جهاز التابلت غير متاح في هذا الفرع.",
  "TABLET_BUSY": "التابلت مشغول.",
  "TABLET_REQUEST_NOT_FOUND": "لم يتم العثور على طلب التوقيع.",
  "TABLET_REQUEST_INVALID": "رفضت خدمة التابلت بيانات العملية. تحقق من البيانات المدخلة وحاول مرة أخرى.",
  "SIGNATURE_NOT_SAVED": "تعذر حفظ التوقيع.",
  "network": "تعذر الاتصال بالخادم. تحقق من الاتصال بالإنترنت.",
  "timeout": "انتهت مهلة الطلب؛ النتيجة غير معروفة.",
  "referenceId": "رقم المرجع: {{requestId}}",
  "PHONE_REQUIRED": "رقم الهاتف مطلوب",
  "PHONE_INVALID": "رقم الهاتف غير صالح",
  "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
  "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة",
  "PHONE_VERIFICATION_REQUIRED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "PHONE_VERIFICATION_INVALID": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "OTP_INVALID": "الرمز غير صحيح",
  "OTP_EXPIRED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ATTEMPTS_EXCEEDED": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
  "OTP_RESEND_TOO_SOON": "إعادة إرسال الرمز غير متاحة الآن",
  "OTP_SEND_LIMIT": "تم إرسال عدد كبير من الرموز لهذا الرقم",
  "OTP_SEND_FAILED": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
  "OTP_ALREADY_VERIFIED": "تم تأكيد رقم الهاتف",
  "OTP_ALREADY_CONSUMED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_BINDING_MISMATCH": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_NOT_VERIFIED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "OTP_CONSUME_WINDOW_PASSED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "CUSTOMERS_UNAVAILABLE": "تعذر التحقق من الرقم لدى نظام العملاء ولم يتم الحفظ، حاول مجددا",
  "IDEMPOTENCY_CONFLICT": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "REQUEST_IN_PROGRESS": "لا يزال هذا الطلب قيد المعالجة",
  "PHONE_VERIFICATION_NOT_ALLOWED": "تحقق من البيانات المدخلة وحاول مرة أخرى."
}
